/**
 * Errors opt into stable Sentry grouping by carrying a `sentryFingerprint: string[]`
 * (e.g. ApiError in @platform/api groups by endpoint + status). Read structurally, not via
 * instanceof: observability must not depend on the packages that own the error classes, and
 * the owning class is the right place to decide its grouping.
 */
export function errorFingerprint(error: unknown): string[] | undefined {
  if (!(error instanceof Error)) {
    return undefined;
  }
  const { sentryFingerprint } = error as { sentryFingerprint?: unknown };
  if (!Array.isArray(sentryFingerprint) || sentryFingerprint.length === 0) {
    return undefined;
  }
  return sentryFingerprint.every((part) => typeof part === 'string') ? sentryFingerprint : undefined;
}
